import { Url } from 'url';

export class CompanyAccessLimit {
  id:number;
  compEmail: string;
  compId: number;
  company_name: string;
  created_date: string;
  totalApprove: number;
  totalUsed: number;
  website_url: string;

  deserialize(input: any): this {
    return Object.assign(this, input);
  }
}
